import React, { createContext, useContext, useState, useCallback, useMemo } from "react";
import fr from "@/i18n/fr.json";
import en from "@/i18n/en.json";

const DICTS = { fr, en };
const I18nContext = createContext(null);

function getNested(obj, path) {
  return path.split(".").reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined), obj);
}

export function I18nProvider({ children }) {
  // Défaut anglais pour tous les nouveaux visiteurs (Itération 50, 12/08/2026) - beaucoup
  // d'utilisateurs étrangers arrivaient sur un site en français sans jamais penser à basculer
  // via le sélecteur de langue (toujours disponible dans la navbar). Un visiteur ayant déjà
  // choisi une langue explicitement (FR ou EN) via ce sélecteur garde toujours son choix
  // (persisté dans localStorage, jamais réinitialisé).
  const [language, setLanguageState] = useState(() => localStorage.getItem("ams_lang") || "en");

  const setLanguage = useCallback((lang) => {
    localStorage.setItem("ams_lang", lang);
    setLanguageState(lang);
  }, []);

  const t = useCallback(
    (path, fallback) => {
      const value = getNested(DICTS[language], path);
      if (value !== undefined) return value;
      const fallbackValue = getNested(DICTS.fr, path);
      return fallbackValue !== undefined ? fallbackValue : fallback || path;
    },
    [language]
  );

  const value = useMemo(() => ({ language, setLanguage, t }), [language, setLanguage, t]);

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
}
